import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { addTuningControllerParameters } from './tuning-controller-parameter.actions';
import {
  TuningControllerParameter,
  tuningControllerParameterId,
  tuningControllerParametersMap,
} from './tuning-controller-parameter.model';
import { createTuningControllerParameterByIdSelector } from './tuning-controller-parameter.selectors';
import { addTuningControllers } from './tuning-controller.actions';

import { AppState } from './index';

@Injectable()
export class TuningControllerParameterEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  addTuningControllerParametersOnAddTuningController$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTuningControllers),
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const tuningControllers = action.tuningControllers;
        const tuningControllerParameters: TuningControllerParameter[] = [];

        tuningControllers.forEach((tuningController) => {
          tuningControllerParametersMap.get(tuningController.type).forEach((tuningControllerParameter) => {
            const parameter = createTuningControllerParameterByIdSelector(
              tuningControllerParameterId(tuningControllerParameter, tuningController),
            ).projector(state.tuningControllerParameters.entities);
            if (!parameter) {
              tuningControllerParameters.push({
                ...tuningControllerParameter,
                id: tuningControllerParameterId(tuningControllerParameter, tuningController),
                tuningControllerId: tuningController.id,
              } as TuningControllerParameter);
            }
          });
        });

        return addTuningControllerParameters({ tuningControllerParameters });
      }),
    ),
  );
}
